import React from 'react';
import { useState } from "react"
import { FiSearch } from 'react-icons/fi'
import { queries } from '../../../../dummy/queries';


const Searches = () => {
    const [query,setQuery] = useState('consectetur adipisicing elit');
    return (
      <React.Fragment>
         {/** Search **/}
        <div id="search">
          <div className="flex items-center justify-between mx-3 my-3">
            <div className="flex items-center">
              <div className="font-semibold">Chat History</div>
            </div>
          </div>
          <div className="search mx-3">
            <div
              className="bg-gray-200 dark:bg-[#111] flex items-center px-3 rounded-md"
            >
              <FiSearch className="stroke-gray-500" />
              <input
                value={query}
                onChange={(e)=>setQuery(e.target.value)}
                placeholder="Search"
                type="text"
                className="w-full border-none bg-transparent p-2 outline-none"
              />
            </div>
          </div>
  
          <ul>
            {queries.map((user,i)=>{
  
              if(!user.excerpt?.toLowerCase()?.includes(query.toLowerCase())) return;
  
             return <li
                key={`query-${i}`}
                className="p-3 hover:bg-gray-50 dark:hover:bg-zinc-900 border border-gray-300 
                dark:border-gray-500 rounded-md mb-3 mx-3 my-2 cursor-pointer"
              >
                <div className="flex gap-2 items-center">
                  <img
                    src={user.avatar}
                    className="h-10 w-10 rounded-full"
                  />
                  <div className="font-medium">{user.name}</div>
                </div>
                 <div className="mt-2 dark:text-gray-400 text-gray-700 text-sm"
                dangerouslySetInnerHTML={{__html:user.excerpt?.toLowerCase()?.replace(query.toLowerCase(), () => `<b className="font-medium bg-blue-500">${query}</b>`) }}
                >
                </div>
              </li>
            })}
          </ul>
        
        </div>
  
      </React.Fragment>
    )
  }
  
export default Searches
